import { render, staticRenderFns } from "./SiftComp.vue?vue&type=template&id=b0aceb6e&scoped=true&"
import script from "./SiftComp.vue?vue&type=script&lang=js&"
export * from "./SiftComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aceb6e",
  null
  
)

export default component.exports